import { Link } from "react-router-dom";
import { Logo } from "./Header";
import { useCountry } from "../context/CountryContext";

export const Footer = () => {
  const { countries } = useCountry();
  const live = countries.filter((c) => c.live);
  return (
    <footer className="relative overflow-hidden bg-ink text-white/60" data-testid="site-footer">
      <div className="brand-bar h-1.5 w-full" />
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <Logo light />
          <p className="mt-4 max-w-sm text-sm leading-relaxed">
            One brand for home and business internet across all 54 African countries. Local prices, local networks, one account.
          </p>
          <p className="mt-6 text-xs uppercase tracking-widest text-slate-500">Live now in</p>
          <p className="mt-1 text-sm text-slate-300">{live.map((c) => c.name).join(" · ") || "—"}</p>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-display text-white">Internet</p>
          <Link className="block hover:text-white" to="/internet/fibre">Fibre</Link>
          <Link className="block hover:text-white" to="/internet/5g">Fixed 5G</Link>
          <Link className="block hover:text-white" to="/internet/lte">LTE</Link>
          <Link className="block hover:text-white" to="/domains">Domains</Link>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-display text-white">Company</p>
          <Link className="block hover:text-white" to="/partners">Become a supplier</Link>
          <Link className="block hover:text-white" to="/portal">Customer portal</Link>
          <Link className="block hover:text-white" to="/supplier">Supplier portal</Link>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-slate-500">© {new Date().getFullYear()} HostAfricair.com</div>
    </footer>
  );
};
